"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodeEnum = void 0;
var ErrorCodeEnum;
(function (ErrorCodeEnum) {
    ErrorCodeEnum["NO_EMAIL_ALIAS"] = "NO_EMAIL_ALIAS";
    ErrorCodeEnum["PARALLEL_EDITING"] = "PARALLEL_EDITING";
    ErrorCodeEnum["CRON_JOB_LOCKED"] = "CRON_JOB_LOCKED";
    ErrorCodeEnum["BANKING_SERVICE_ERROR"] = "BANKING_SERVICE_ERROR";
    ErrorCodeEnum["WEAVR_AUTH_REQUIRED"] = "WEAVR_AUTH_REQUIRED";
    ErrorCodeEnum["WEAVR_STEP_UP_AUTH_REQUIRED"] = "WEAVR_STEP_UP_AUTH_REQUIRED";
    ErrorCodeEnum["WEAVR_ONE_CHALLENGE_LIMIT_REMAINING"] = "WEAVR_ONE_CHALLENGE_LIMIT_REMAINING";
    ErrorCodeEnum["WEAVR_CHALLENGE_LIMIT_EXCEEDED"] = "WEAVR_CHALLENGE_LIMIT_EXCEEDED";
    ErrorCodeEnum["MOBILE_ALREADY_ENROLLED"] = "MOBILE_ALREADY_ENROLLED";
    ErrorCodeEnum["MOBILE_ENROLLEMENT_RESET"] = "MOBILE_ENROLLEMENT_RESET";
    ErrorCodeEnum["REQUESTING_SESSION_NOT_FOUND"] = "REQUESTING_SESSION_NOT_FOUND";
    ErrorCodeEnum["REQUESTING_SESSION_NOT_AUTHENTICATED"] = "REQUESTING_SESSION_NOT_AUTHENTICATED";
    ErrorCodeEnum["MAINTENANCE"] = "MAINTENANCE";
    ErrorCodeEnum["INVALID_SYSTEM_TIME"] = "INVALID_SYSTEM_TIME";
    ErrorCodeEnum["INVALID_EXPENSE_AMOUNTS"] = "INVALID_EXPENSE_AMOUNTS";
    ErrorCodeEnum["MISSING_IP_ADDRESS"] = "MISSING_IP_ADDRESS";
})(ErrorCodeEnum = exports.ErrorCodeEnum || (exports.ErrorCodeEnum = {}));
